import { Tab } from '@design/components/tab-lines/TabLines';
import clsx from 'clsx';

import styles from './EarningsTabPanel.module.scss';

export interface EarningsTabPanelProps<T> {
  tabs: Tab<T>[];
  activeTab: T;
  onChange: (index: number, tabKey: T) => void;
  className?: string;
}

export const EarningsTabPanel = <T extends string>({
  tabs,
  activeTab,
  onChange,
  className,
}: EarningsTabPanelProps<T>) => {
  const currentPanel = tabs.find(tab => tab.tabKey === activeTab)?.renderPanel;

  return (
    <div
      className={clsx(styles.root, className)}
      data-testid="revamp-earnings-tab-panel"
    >
      <div className={styles.tablist} role="tablist">
        {tabs.map(({ tabKey, tabLabel }, index) => {
          const tabId = `revamp-earnings-tab-panel-tab-${tabKey}`;
          const panelId = `revamp-earnings-tab-panel-panel-${tabKey}`;

          return (
            <button
              type="button"
              key={tabKey}
              id={tabId}
              className={clsx(styles.tab, {
                [styles.tabActive]: activeTab === tabKey,
              })}
              data-testid={`revamp-earnings-tab-panel-tab-${tabKey}`}
              role="tab"
              aria-selected={activeTab === tabKey}
              aria-controls={panelId}
              onClick={() => onChange(index, tabKey)}
            >
              {tabLabel}
            </button>
          );
        })}
      </div>

      <div
        className={styles.tabPanel}
        data-testid="revamp-earnings-tab-panel-content"
        role="tabpanel"
        id={`revamp-earnings-tab-panel-panel-${activeTab}`}
        aria-labelledby={`revamp-earnings-tab-panel-tab-${activeTab}`}
      >
        {currentPanel}
      </div>
    </div>
  );
};
